<template>
  <li>
    <BaseCaption class="terms__caption" v-if="text.subtitle" :text="text.subtitle" :tag="'h3'" />
    <BaseText class="terms__descr" v-for="(textItem, index) in text.items" :key="index" :text="textItem" />
  </li>
</template>

<script>
export default {
  props: {
    text: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// components/TermsTextItem.vue